module.exports = __webpack_public_path__ + "static/media/edit.085f3e08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/edit.svg
// module id = ./src/statics/images/edit.svg
// module chunks = 0